// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileEmptyState-cls1_6G8","cls2":"ProfileEmptyState-cls2_XzP ProfileEmptyState-cls1_6G8"};